import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { changeSidebarType, UpdateEditRestriction } from '../../store/actions';

// Layout Related Components
import Header from './Header';
import Sidebar from './Sidebar';

interface Props {
  leftSideBarType: string;
  changeSidebarType: (leftSideBarType: string, isMobile?: boolean) => void;
  children: any;
  location: {
    pathname: string;
  };
  history: any;
  isAllowed: boolean;
  UpdateEditRestriction: (isAllowed: boolean) => void;
}

interface State {
  isMobile: boolean;
}

class Layout extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    };
    this.toggleMenuCallback = this.toggleMenuCallback.bind(this);
  }

  componentDidMount() {
    if (this.props.leftSideBarType) {
      this.props.changeSidebarType(this.props.leftSideBarType);
    }
  }

  toggleMenuCallback = () => {
    if (this.props.leftSideBarType === 'default') {
      this.props.changeSidebarType('condensed', this.state.isMobile);
    } else if (this.props.leftSideBarType === 'condensed') {
      this.props.changeSidebarType('default', this.state.isMobile);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div id="layout-wrapper">
          {/*{<Header
            toggleMenuCallback={this.toggleMenuCallback}
            pathname={this.props.location.pathname}
            history={this.props.history}
            isAllowed={this.props.isAllowed}
            UpdateEditRestriction={(isAllowed) => this.props.UpdateEditRestriction(isAllowed)}
          />}*/}
          {/* {
            this.props.location.pathname.includes('dashboard') &&
            <Sidebar
                type={this.props.leftSideBarType}
                pathname={this.props.location.pathname}
                isMobile={this.state.isMobile}
            />
          } */}
          <div className={`main-content ${!this.props.location.pathname.includes('dashboard') && 'without-sidebar'}`}>
            {this.props.children}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    ...state.Layout,
    ...state.EditRestriction
  };
};

export default connect(
  mapStateToProps, {
    changeSidebarType,
    UpdateEditRestriction
  }
)(withRouter(Layout));
